import React from 'react';
import Icon from './Icon';

// Slim attendee row used on the sponsor detail page — no avatar, no address,
// no company line (the page itself identifies the company). Name + title +
// tap-to-call phone + tap-to-email.
export default function SupplierAttendeeRow({ attendee }) {
  const phoneDigits = attendee.phone ? attendee.phone.replace(/\D/g, '') : '';
  const fullName = `${attendee.first || ''} ${attendee.last || ''}`.trim();

  return (
    <div className="portal-supplier-attendee">
      <div className="portal-supplier-attendee-name">{fullName}</div>
      {attendee.title && (
        <div className="portal-supplier-attendee-title">{attendee.title}</div>
      )}
      <div className="portal-supplier-attendee-contacts">
        {attendee.phone && (
          <a
            href={`tel:${phoneDigits}`}
            className="portal-supplier-attendee-link"
          >
            <Icon name="phone" size={14} className="portal-supplier-attendee-icon" />
            <span>{attendee.phone}</span>
          </a>
        )}
        {attendee.email && (
          <a
            href={`mailto:${attendee.email}`}
            className="portal-supplier-attendee-link"
          >
            <Icon name="mail" size={14} className="portal-supplier-attendee-icon" />
            <span>{attendee.email}</span>
          </a>
        )}
      </div>
    </div>
  );
}
